export default __webpack_public_path__ + "static/media/onboarding-app-preview-placeholder.95a0c403.png";